module.exports = __webpack_public_path__ + "static/media/TR.d0a01b0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TR.svg
// module id = 378
// module chunks = 0